import { MODES } from '@avanta/shared/constants/common';
import { type Mode } from '@avanta/shared/types/common';
import { cn } from '@avanta/shared/utils/cn';

interface SlotButtonProps {
  onClick: () => void;
  isActive?: boolean;
  disabled?: boolean;
  mode?: Mode;
}

export const SlotButton = ({
  onClick,
  isActive = false,
  disabled = false,
  mode = MODES.primary,
  children,
}: React.PropsWithChildren<SlotButtonProps>): React.ReactElement => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={cn(
      'h-8 w-full inline-flex items-center justify-center border rounded p-1 transition-colors',
      'bg-white border-teal-500',
      'hover:bg-plum-100 hover:border-transparent hover:shadow-md',
      isActive && 'bg-mint-100 hover:bg-mint-100 hover:border-teal-500 hover:shadow-none',
      isActive &&
        mode === MODES.secondary &&
        'bg-denim-100 hover:bg-denim-100 hover:border-denim-200',
      mode === MODES.secondary && 'border-denim-200',
      disabled &&
        'border-plum-200 cursor-not-allowed hover:bg-white hover:border-plum-200 hover:shadow-none'
    )}
  >
    <span
      className={cn(
        'text-sm font-medium leading-none',
        disabled ? 'text-beige-200' : 'text-denim-800'
      )}
    >
      {children}
    </span>
  </button>
);
